module.exports = __webpack_public_path__ + "images/800x800_Individual_0000s_0012_Suso_Apple-&-Elderflower_2.png";